import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#787887"
      d="M12 7.5v1a.38.38 0 0 1-.375.375h-2.75v2.75A.38.38 0 0 1 8.5 12h-1a.36.36 0 0 1-.375-.375v-2.75h-2.75A.36.36 0 0 1 4 8.5v-1a.38.38 0 0 1 .375-.375h2.75v-2.75A.38.38 0 0 1 7.5 4h1c.188 0 .375.188.375.375v2.75h2.75c.188 0 .375.188.375.375m3.75.5A7.75 7.75 0 0 1 8 15.75 7.75 7.75 0 0 1 .25 8 7.75 7.75 0 0 1 8 .25 7.75 7.75 0 0 1 15.75 8m-1.5 0c0-3.437-2.812-6.25-6.25-6.25A6.25 6.25 0 0 0 1.75 8 6.23 6.23 0 0 0 8 14.25 6.25 6.25 0 0 0 14.25 8"
    />
  </svg>
);
export default SvgPlusCircle;
